import axios from "axios";
import { getApiUrl, getStatisticsApiUrl } from "../commons/common";

const axiosInstance = axios.create({
    baseURL: getApiUrl(),
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// 요청마다 최신 토큰을 헤더에 적용
axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// 통계(대시보드) 전용 axios 인스턴스
export const statisticsAxiosInstance = axios.create({
    baseURL: getStatisticsApiUrl(),
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
});

statisticsAxiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default axiosInstance;